import { UnknownAction } from "redux";
import { isPublishAction } from "../actions/Publish.js";
import { Publish } from "../types/index.js";

const initialState: Publish = { status: "ready" };

const setPublish = (publish: Publish): Publish => {
  return publish;
};

const reducer = (state = initialState, action: UnknownAction) => {
  if (!isPublishAction(action)) {
    return state;
  }
  switch (action.type) {
    case "POST_PUBLISH_SUCCESS":
      return setPublish(action.publish);

    case "GET_PUBLISH_SUCCESS":
      return setPublish(action.publish);

    default:
      return state;
  }
};

export default reducer;
